module.exports = __webpack_public_path__ + "img/card-r07.24df9505.jpg";